import mushroom from 'pmcc-api';
import LanguageService from './LanguageService';
import { blockUi, unblockUi } from '../shared/utils';

window.requestCount = 0;
window.mushroom = mushroom;
//let ApiService = {};

let ApiService = (objData) => {
    beginLoading(objData);

    if (objData.type && objData.type != "views") {
        return mushroom[objData.module][objData.type + "Async"](objData.value, objData.params)
            .then(response => {
                checkSuccess(response, objData);
                return response;
            })
            .catch(error => {
                checkError(error, objData);
                throw error;
            });
    } else {
        return mushroom[objData.module].views[objData.viewAction + "Async"](objData.value, objData.params)
            .then(response => {
                checkSuccess(response, objData);
                return response;
            })
            .catch(error => {
                checkError(error, objData);
                throw error;
            });
    }

};

export let callCustomMethodAsync = (objData) => {
    beginLoading(objData);
    const resource = mushroom[objData.module];
    const methodName = objData.type + "Async";
    if (!resource || typeof resource[methodName] !== "function") {
        finishLoading(objData);
        throw new Error(`API method not found: ${objData.module}.${methodName}`);
    }

    return resource[methodName]({
            params: objData.params,
            body: objData.body
        })
        .then(response => {
            checkSuccess(response, objData);
            return response;
        })
        .catch(error => {
            checkError(error, objData);
            throw error;
        });
};

ApiService.clearCache = (url) => {
    mushroom.$cache.invalid(url);
};

function beginLoading(objData) {
    objData.__useGlobalLoading = !objData.dontLoading;
    if (!objData.__useGlobalLoading) {
        return;
    }
    if (!window.requestCount || window.requestCount < 0) {
        window.requestCount = 0;
    }
    if (window.requestCount == 0) {
        blockUi();
    }
    window.requestCount += 1;
}

function finishLoading(objData) {
    if (!objData.__useGlobalLoading) {
        return;
    }
    window.requestCount = Math.max((window.requestCount || 0) - 1, 0);
    if (window.requestCount == 0) {
        setTimeout(()=>{
          unblockUi();
        }, 1000)
    }
}

function checkSuccess(res, objData) {

    finishLoading(objData);
    if (objData.message && objData.message.success && objData.message.success == "hidden") {
        return;
    }
    if (objData.message && objData.message.success && objData.message.success != "hidden") {
        window.toastr.success(objData.message.success);
    } else {
        if (objData.type == "create") {
            window.toastr.success(LanguageService.lang.c_addSuccess);
        } else if (objData.type == "partialUpdate") {
            window.toastr.success(LanguageService.lang.c_updateSuccess);
        } else if (objData.type == "delete") {
            window.toastr.success(LanguageService.lang.c_deleteSuccess);
        } else if (objData.type == "batchDelete") {
            if (res.meta && res.meta.successIds && res.meta.successIds.length > 0) {
                window.toastr.success(LanguageService.lang.c_delete + " " + res.meta.successIds.length + " " + LanguageService.lang.c_recordSuccess);
            }
            if (res.meta && res.meta.failureIds && res.meta.failureIds.length > 0) {
                window.toastr.error(LanguageService.lang.c_delete + " " + res.meta.failureIds.length + " " + LanguageService.lang.c_recordError);
            }
        }
    }
}

function checkError(err, objData) {

    finishLoading(objData);
    if (objData.message && objData.message.error && objData.message.error == "hidden") {
        return;
    }
    if (objData.message && objData.message.error && objData.message.error != "hidden") {
        window.toastr.error(objData.message.error);
    } else {
        if (objData.type == "findById") {
            window.toastr.error(LanguageService.lang.c_findError);
        } else if (objData.type == "list") {
            window.toastr.error(LanguageService.lang.c_findError);
        } else if (objData.type == "create") {
            window.toastr.error(LanguageService.lang.c_addError);
        } else if (objData.type == "partialUpdate") {
            window.toastr.error(LanguageService.lang.c_updateError);
        } else if (objData.type == "batchDelete") {
            window.toastr.error(LanguageService.lang.c_deleteError);
        } else if (objData.type == "views") {
            window.toastr.error(LanguageService.lang.c_findError);
        } else {
            window.toastr.error(LanguageService.lang.c_findError);
        }

    }
}


export default ApiService;
